import React from 'react';

export class TitleDivider extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <div className="title-divider typo-body">
        { this.props.children }
      </div>
    );
  }
}
